import React from 'react'
import { FaGithub } from 'react-icons/fa'

export const ProjectCard = ({ title, description, imgUrl, githubLink, liveUrl, techStack, signIn, password, projectId}) => {
  return (
    <div className="project_card_section">
        <div className="project_img_box">
            <img src={imgUrl} alt="" className="project_img" />
            <div className="project_text">
                <h4>{title}</h4>
                <span>{description}</span>
                    <div className="tech_stack">
                         <div className='project_icons'>{techStack}</div>
                    </div>
                    <div className="appSignIn">
                        <div className="signinInfo">{signIn}</div>
                        <div className="passwordInfo">{password}</div>
                    </div>
                
                <div className="project_buttons">
                    <a href={githubLink} className="small_button_dark"><FaGithub className='project_git'/> Github</a>
                    <a href={liveUrl} className="small_button_dark">Live</a>
                </div>
            </div>
        </div> 
    </div>
  )
}
